module.exports = __webpack_public_path__ + "static/media/old sf-steuart-2-3-4.8312d716.png";